export const extend = function () {
  const extended = {}
  let deep = false
  let i = 0
  const length = arguments.length

  // Check if a deep merge
  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0]
    i++
  }

  // Merge the object into the extended object
  const merge = function (obj) {
    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        // If deep merge and property is an object, merge properties
        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = extend(true, extended[prop], obj[prop])
        } else {
          extended[prop] = obj[prop]
        }
      }
    }
  }

  // Loop through each object and conduct a merge
  for (;i < length; i++) {
    const obj = arguments[i]
    merge(obj)
  }

  return extended
}

export const $ = function (selector, parent) {
  return (parent || document).querySelector(selector)
}

export const $$ = function (selector, parent) {
  return [...(parent || document).querySelectorAll(selector)]
}

export const offset = function (element) {
  const offset = element.getBoundingClientRect()

  return {
    top: offset.top + window.scrollY,
    left: offset.left + window.scrollX
  }
}

export const addEvent = function (element, type, handler) {
  const customEvent = new Event(type)

  element.addEventListener(type, handler)

  return customEvent
}

export const removeEvent = function (element, type, handler) {
  if (element.detachEvent) {
    element.detachEvent('on' + type, handler)
  } else {
    element.removeEventListener(type, handler)
  }
}

export const hasParentsClass = function (element, classname) {
  if (element.classList.contains(classname)) {
    return true
  }

  return element.parentElement && hasParentsClass(element.parentElement, classname)
}

export const getCookie = function (key) {
  if (document.cookie) {
    function escape (string) {
      return string.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1')
    };

    const match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(key) + '=([^;]*)'))
    return match ? match[1] : null
  }
}

export const setCookie = function (key, value, maxAge) {
  if (!maxAge) {
    maxAge = 60 * 60 * 24 * 365
  }
  document.cookie = key + '=' + value + '; path=/; max-age=' + maxAge + ';'
}
